import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { tap } from 'rxjs';

export const marketInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);
    const isBrowser = isPlatformBrowser(platformId);
    return next(req).pipe(
        tap((event) => {
            if (event instanceof HttpResponse && isBrowser) {
                const marketFromHeader = event.headers.get('currentMarket');

                if (marketFromHeader) {
                    sessionStorage.setItem('currentMarket', marketFromHeader);
                } else {
                    sessionStorage.setItem('currentMarket', '');
                }
            }
        })
    );
};
